import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import { sectorService } from '../services/sector.service';
import { ganttAPI } from '../utils/customGanttPlugin';

/**
 * Hook para manejar la carga inicial de la vista de la gantt
 * @returns {Object} Estado de carga de la vista
 */
export const useScheduleView = () => {
  const { t } = useTranslation();
  const projectState = useSelector((state) => state.projectState);

  const loadScheduleView = async () => {
    try {
      const { allSectors } = projectState;
      if (!allSectors) return false;

      const sector = await sectorService.show(projectState.sectorSelected);
      if (!sector?.sector) return false;

      const currentSector = sector.sector;
      const copySector = {
        ...currentSector,
        cncs: [],
        constraints: [],
        weekcommitments: []
      };

      sessionStorage.setItem('currentSector', JSON.stringify(copySector));
      ganttAPI.updateFormatter();
      window.localStorage.setItem('scale', JSON.stringify('month'));

      return true;
    } catch (error) {
      message.error(t('error_loading_schedule_view'));
      return false;
    }
  };

  return {
    loadScheduleView
  };
};
